<template>
  <div v-if="error" data-cy="server-error">
    <div v-for="(er, index) in errors" :key="index" class="b-server-error mt-4 mx-6">
      <div class="b-server-error__icon-wrap p-4">
        <dynamic-icon icon="warning"></dynamic-icon>
      </div>
      <div class="b-server-error__text-wrap px-4"><span v-html="buildErrorMessage(er)"></span></div>
    </div>
  </div>
</template>
<script>

import buildErrorMessage from "../mixins/buildErrorMessage";

export default {
  props: {
    error: {
      required: true,
      default: null
    }
  },
  mixins: [buildErrorMessage],
  computed: {
    errors() {
      console.error(this.error);
      // Error in js
      if (this.error.response == null) {
        if (Array.isArray(this.error)) {
          const a = this.error.map(function(e) {
            return { message: e };
          });
          return a;
        }
        return [{ message: this.error }];
      }
      // Error not authorize
      if (this.error.response.status === 401) {
        this.$store.dispatch("logout");
        this.$router.push({name: "Login"});
        return [{ message: "401: Not Authorized" }];
      }

      // Error from server
      if (this.error.response.data.exceptions == null)
        return [{ message: this.error.response.data.errors }];
      return this.error.response.data.exceptions;
    }
  }
};
</script>

